<template>
  <div>
    <!-- GST LIST MODAL -->
    <b-modal
      id="manage-gst"
      ref="manage-gst"
      centered
      hide-footer
      size="lg"
      @hidden="closeModalBox"
    >
      <template v-slot:modal-title>Manage GSTIN</template>
      <div class="d-block group-listing">
        <b-row class="pb-2 mt-2 gst-header" v-if="gstList == ''">
          <b-col md="12" class="text-center text-muted">No GST Found</b-col>
        </b-row>
        <b-row class="pb-2 mt-2 gst-header" v-if="gstList != ''">
          <b-col md="5" class="pl-5">Legal name</b-col>
          <b-col md="3">State</b-col>
          <b-col md="4">GSTIN</b-col>
        </b-row>
        <b-row class="py-2 mb-2" v-for="list in gstList" :key="list.id">
          <b-col md="5">
            <div class="pt-0" v-if="type == 'login'">
              <b-form-radio
                name="radio-options"
                v-model="selected"
                :value="list"
              >
                <label :for="list.name"
                  >&nbsp; &nbsp; {{ list.legal_name }}</label
                >
              </b-form-radio>
            </div>
            <div class="ml-4" v-if="type == 'profile'">
              &nbsp; &nbsp; {{ list.legal_name }}
            </div>
          </b-col>
          <b-col md="3">{{ list.state_name }}</b-col>
          <b-col md="4">
            <b-row>
              <b-col>{{ list.gstin }}</b-col>
              <b-col class="text-right">
                <img
                  src="../assets/images/remove.svg"
                  alt="Clear"
                  @click="removeGst(list)"
                  style="cursor: pointer"
                  :disabled="$loading"
                />
                <font-awesome-icon
                  :icon="['fa', 'pencil-alt']"
                  class="mt-1 ml-3"
                  @click="openGstModal('update', list)"
                  style="cursor: pointer"
                  :id="'remove-gst-' + list.gstin"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-input-group class="mb-3 mt-2 add-group-field" v-if="hide">
          <template v-slot:append>
            <b-input-group-text>
              <img
                src="../assets/images/remove.svg"
                alt="Clear"
                @click="clearField()"
                style="cursor: pointer"
              />
            </b-input-group-text>
          </template>
          <b-form-input v-model="groupName"></b-form-input>
        </b-input-group>
        <p class="my-3 pl-1">
          <b-link
            title="Add new GSTIN"
            class="add-new"
            @click="openGstModal('add')"
            id="add-new-gstin"
          >
            <img src="../assets/images/add_grey.svg" alt=" " class="mr-2" /> Add
            new GSTIN
          </b-link>
        </p>
      </div>
      <div class="text-right">
        <b-button
          class="mt-3"
          variant="primary"
          :disabled="$loading"
          @click="sendSelectedData"
          v-if="type == 'login' && gstList != ''"
          id="confirm-selected"
        >
          <span v-if="$loading == false">Confim Selected</span>
          <b-spinner small v-if="$loading == true"></b-spinner>
        </b-button>
      </div>
    </b-modal>

    <!-- GST ADD/UPDATE MODAL -->
    <b-modal
      id="add-gst"
      ref="add-gst"
      centered
      hide-footer
      size="sm"
      @hidden="clearGstModal"
      v-if="open"
    >
      <template v-slot:modal-title>{{ gstTitle }} GSTIN</template>
      <div class="d-block group-listing">
        <label for="legal-name" id="label-legal-name">Legal name</label>
        <b-form-input
          id="legal-name-input"
          v-model="addGSTIN.name"
          class="my-2"
          placeholder="Enter legal name"
          @change="clearError"
          :disabled="$loading"
        ></b-form-input>
        <label for="state-name" id="label-state">State</label>
        <b-form-select
          v-model="addGSTIN.state"
          class="my-2 fs-13"
          :disabled="$loading"
          id="select-state"
        >
          <option value="Select state" disabled>Select state</option>
          <option
            v-for="state in states"
            :value="state.name"
            v-text="state.name"
            :key="state.id"
            :id="state.name"
          ></option>
        </b-form-select>
        <label for="gst" id="label-gstin">GST Identification Number</label>
        <b-form-input
          id="input-gstin"
          v-model="addGSTIN.gstin"
          class="my-2"
          placeholder="Enter 15 digit GSTIN…"
          @keyup.delete="clearError"
          :disabled="$loading"
          :readonly="readonlyGst"
          maxlength="15"
        ></b-form-input>
        <p
          v-if="addGstError.status"
          style="color: red"
          v-text="addGstError.message"
        ></p>
      </div>
      <div class="text-right">
        <b-button
          class="mt-3"
          id="save-gstin"
          variant="primary"
          :disabled="gstValidation || $loading"
          @click="gstValidator"
        >
          <span v-if="$loading == false">Save GSTIN</span>
          <b-spinner small v-if="$loading == true"></b-spinner>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "add-gst-modal",
  props: ["open", "mobile", "type", "selected_gst"],
  data() {
    return {
      gstList: "",
      hide: false,
      gstTitle: "Add",
      addGSTIN: {
        name: "",
        state: "",
        gstin: "",
        id: "",
      },
      states: [],
      addGstError: {
        message: "",
        status: false,
      },
      readonlyGst: false,
      selected: {},
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"];
      },
    }),
    gstValidation() {
      let check = true;
      if (
        this.addGSTIN.gstin.length == 15 &&
        this.addGSTIN.name != "" &&
        this.addGSTIN.state != "Select state"
      ) {
        check = false;
      }
      return check;
    },
  },
  watch: {
    open() {
      if (this.open) {
        this.getGstList();
      } else {
        this.$refs["manage-gst"].hide();
      }
    },
  },
  methods: {
    gstValidator() {
      let regExp = /(0[0-9]|1[1-9]|2[0-9]|3[0-7])[A-Z]{3}[CPHFATBLJG]{1}[A-Z]{1}\d{4}[A-Z]{1}[A-Z0-9]{3}/g.test(
        this.addGSTIN.gstin.toUpperCase()
      );

      if (regExp == true) {
        this.addNewGst();
      } else {
        this.addGstError = {
          message:
            "Invalid GST, must be in the format of '22-AAAAA0000A-1-Z-5'.",
          status: true,
        };
      }
    },
    clearError() {
      this.addGstError.status = false;
      this.addGstError.message = "";
    },
    sendSelectedData() {
      this.$emit("gstData", this.selected);
      this.closeModalBox();
    },
    closeModalBox() {
      if (this.gstList.length == 0) {
        let empty = { gstin: "" };
        this.$emit("gstData", empty);
      }
      this.$emit("closeGstModal");
    },
    getGstList(type) {
      let stateData = {
        trans_from: this.state.system.trans_from,
        country_id: this.state.system.country_details.country_id,
        url: "/location/get-state",
      };
      axios.post(stateData.url, stateData).then((response) => {
        this.states = response.data.data;
      });

      this.$loading = true;
      let data = {
        url: "/customer/gst/list",
        v_id: this.state.sessions.user.v_id,
        api_token: this.state.sessions.user.api_token,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        mobile: this.mobile,
      };
      axios
        .post(data.url, data)
        .then((res) => {
          this.$loading = false;
          this.gstList = res.data.list;
          if (this.gstList != "") {
            if (this.selected_gst != "") {
              this.gstList.filter((item) => {
                if (item.name == this.selected_gst) {
                  this.selected = item;
                }
              });
            } else {
              this.selected = this.gstList[0];
            }
          }
          if (type == "add_new_gst") {
            this.selected = this.gstList[0];
            this.$refs["add-gst"].hide();
          }
          this.$refs["manage-gst"].show();
        })
        .catch(() => {
          this.$loading = false;
          this.closeModalBox();
        });
    },
    addNewGst() {
      this.$loading = true;
      let data = {
        url:
          this.gstTitle == "Update"
            ? "/customer/gst/update"
            : "/customer/gst/create",
        v_id: this.state.sessions.user.v_id,
        api_token: this.state.sessions.user.api_token,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        mobile: this.mobile,
        legal_name: this.addGSTIN.name,
        state_id: this.addGSTIN.state,
        gstin:
          this.gstTitle == "Update"
            ? this.addGSTIN.id
            : this.addGSTIN.gstin.toUpperCase(),
      };
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "fail") {
            this.addGstError.message = res.data.message;
            this.addGstError.status = true;
            this.$loading = false;
          } else if (res.data.status == "success") {
            this.getGstList("add_new_gst");
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    openGstModal(type, item) {
      if (type == "add") {
        this.gstTitle = "Add";
        this.addGSTIN.state = "Select state";
      } else if (type == "update") {
        this.addGSTIN.name = item.legal_name;
        this.addGSTIN.state = item.state_name;
        this.addGSTIN.gstin = item.gstin;
        this.addGSTIN.id = item.id;
        this.readonlyGst = true;
        this.gstTitle = "Update";
      }

      this.$refs["add-gst"].show();
    },
    removeGst(item) {
      this.$loading = true;
      let data = {
        url: "/customer/gst/remove",
        v_id: this.state.sessions.user.v_id,
        api_token: this.state.sessions.user.api_token,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        mobile: this.mobile,
        gstin: item.id,
      };
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "success") {
            var index = this.gstList.indexOf(item);
            if (index > -1) {
              this.gstList.splice(index, 1);
            }
          }
          let empty = { gstin: "" };
          this.$emit("gstData", empty);
          this.selected = this.gstList[0];
          this.$loading = false;
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    clearGstModal() {
      this.readonlyGst = false;
      this.addGSTIN = { name: "", state: "", gstin: "", id: "" };
      this.clearError();
    },
  },
};
</script>

<style></style>
